import React from 'react';

const Document = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.78105 2.11308C2 2.89413 2 4.1512 2 6.66536V9.33203C2 11.8462 2 13.1033 2.78105 13.8843C3.5621 14.6654 4.81917 14.6654 7.33333 14.6654H8.66667C11.1808 14.6654 12.4379 14.6654 13.2189 13.8843C14 13.1033 14 11.8462 14 9.33203V6.66536C14 4.1512 14 2.89413 13.2189 2.11308C12.4379 1.33203 11.1808 1.33203 8.66667 1.33203H7.33333C4.81917 1.33203 3.5621 1.33203 2.78105 2.11308ZM4.83333 5.33203C4.83333 5.05589 5.05719 4.83203 5.33333 4.83203H10.6667C10.9428 4.83203 11.1667 5.05589 11.1667 5.33203C11.1667 5.60817 10.9428 5.83203 10.6667 5.83203H5.33333C5.05719 5.83203 4.83333 5.60817 4.83333 5.33203ZM4.83333 7.9987C4.83333 7.72256 5.05719 7.4987 5.33333 7.4987H10.6667C10.9428 7.4987 11.1667 7.72256 11.1667 7.9987C11.1667 8.27483 10.9428 8.4987 10.6667 8.4987H5.33333C5.05719 8.4987 4.83333 8.27483 4.83333 7.9987ZM5.33333 10.1654C5.05719 10.1654 4.83333 10.3892 4.83333 10.6654C4.83333 10.9415 5.05719 11.1654 5.33333 11.1654H8.66667C8.9428 11.1654 9.16667 10.9415 9.16667 10.6654C9.16667 10.3892 8.9428 10.1654 8.66667 10.1654H5.33333Z"
      fill="#6930CA"
    />
  </svg>
);

export default Document;
